import { Drawer, DrawerContent } from '@/components/ui/Drawer/drawer';
import { cn } from '@/utils/cn';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  contentClassName?: string;
}

const BottomSheetModal = ({ open, onOpenChange, children, contentClassName }: Props) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
      <DrawerContent className="bg-main-800 border-none text-white rounded-t-2xl px-6 pb-8 pt-3">
        <div className="mx-auto mb-5.5 h-1 w-10 shrink-0 rounded-full bg-c600" />

        <div className={cn('flex flex-col mt-3.75', contentClassName)}>
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default BottomSheetModal;
